import {
	APP_INITIALIZER,
	ApplicationConfig,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import {
	provideHttpClient,
	withInterceptorsFromDi,
	withInterceptors,
	HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { routes } from './app.routes';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { tokenInterceptor } from './interceptors/token.interceptor';
import { SiteSettingsService } from './services/site-settings.service';

// Load site settings before any component renders
function initSettings(settings: SiteSettingsService) {
	return () => settings.loadFromJson();
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(
			routes,
			withInMemoryScrolling({
				scrollPositionRestoration: 'top',
				anchorScrolling: 'enabled',
			})
		),
		provideHttpClient(withInterceptorsFromDi(), withInterceptors([tokenInterceptor])),
		{
			provide: APP_INITIALIZER,
			useFactory: initSettings,
			deps: [SiteSettingsService],
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LoaderInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true,
		},
	],
};
